export type VsaBypassReason = 'CLIENT_WAIVER' | 'DOCUSIGN_WEBHOOK_ISSUE';

export const VSA_BYPASS_REASON_OPTIONS: {
  value: VsaBypassReason;
  label: string;
}[] = [
  { value: 'CLIENT_WAIVER', label: 'Client Waiver' },
  {
    value: 'DOCUSIGN_WEBHOOK_ISSUE',
    label: 'DocuSign / Web Hook Issue'
  }
];
